import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Reveal } from "./Reveal";

export default function SectionHeader({ kicker, title, link, linkLabel, linkTestId }) {
  return (
    <Reveal className="flex flex-col gap-6 md:flex-row md:items-end md:justify-between">
      <div className="max-w-2xl">
        <p className="kicker">{kicker}</p>
        <h2 className="mt-5 text-balance text-3xl font-medium leading-[1.2] tracking-tight text-slate-100 lg:text-4xl">
          {title}
        </h2>
      </div>
      {link && (
        <Link
          to={link}
          className="group inline-flex shrink-0 items-center gap-2 font-mono text-[11px] uppercase tracking-[0.22em] text-slate-400 transition-colors duration-300 hover:text-glow"
          data-testid={linkTestId}
        >
          {linkLabel}
          <ArrowRight size={14} className="transition-transform duration-300 group-hover:translate-x-1" />
        </Link>
      )}
    </Reveal>
  );
}
